import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';
import { AdminService } from 'services/admin/admin';
import { ApiStatus } from 'types/enums/ApiStatus';

type CompanyNotCalledState = {
  status: ApiStatus.NOT_CALLED;
  errorCode?: never;
  organizationUserRole?: never;
};

type CompanyLoadedState = {
  status: Exclude<ApiStatus, ApiStatus.NOT_CALLED>,
  organizationUserRole: OrganizationUserRole,
  errorCode?: number
};

export type CompanyState = CompanyNotCalledState | CompanyLoadedState;

const initialState: CompanyState = {
  status: ApiStatus.NOT_CALLED,
};

export const fetchOrganizationUserRoles = createAsyncThunk(
  'company/fetchOrganizationUserRole',
  async (userId: number, { rejectWithValue }) => {
    try {
      const organizationUserRole = await AdminService.Company.GetOrganizationUserRoles(userId);
      return organizationUserRole[0];
    } catch (error: unknown) {
      const axiosError = error as AxiosError;
      return rejectWithValue(axiosError.response?.status);
    }
  },
);

const companySlice = createSlice({
  name: 'company',
  initialState: initialState as CompanyState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchOrganizationUserRoles.pending, (state) => {
        state.status = ApiStatus.LOADING;
        state.errorCode = undefined;
      })
      .addCase(fetchOrganizationUserRoles.fulfilled, (state, { payload }) => {
        if (!payload) return;

        state.status = ApiStatus.SUCCEEDED;
        state.organizationUserRole = payload;
      })
      .addCase(fetchOrganizationUserRoles.rejected, (state, { payload }) => {
        state.status = ApiStatus.FAILED;
        state.errorCode = payload as number;
      });
  },
});

export default companySlice.reducer;
